export const GET_CHAPTERS_SUCCEEDED = 'GET_CHAPTERS_SUCCEEDED';
export const GET_ASSIGNMENT_SUCCEEDED = 'GET_ASSIGNMENT_SUCCEEDED';



// WEBPACK FOOTER //
// ./src/actions/Constants.js